<script>
    import * as animateScroll from "svelte-scrollto";
    export let subSelection;
    import { onMount } from 'svelte';
    export let handleClickNav;

    let responsiveCols = "col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2";
    let y, innerHeight;
    let row2, row2Image, calculatedRow2Start, translate2Calculated, conditionRow2;
    let row3, row3Image, calculatedRow3Start, translate3Calculated, conditionRow3;
    let row5, row5Image, calculatedRow5Start, translate5Calculated, conditionRow5;

    $: if (y) {
        calculatedRow2Start = row2.getBoundingClientRect().y - innerHeight/1.5;
        conditionRow2 = row2Image.getBoundingClientRect().width + calculatedRow2Start > 0;
        translate2Calculated = conditionRow2 ? Math.pow(row2Image.getBoundingClientRect().width + calculatedRow2Start, 2) : 0;

        calculatedRow3Start = row3.getBoundingClientRect().y - innerHeight/10;
        conditionRow3 = row3Image.getBoundingClientRect().width*0.35 + calculatedRow3Start > 0;
        translate3Calculated = conditionRow3 ? Math.pow(row3Image.getBoundingClientRect().width*0.35 + calculatedRow3Start, 2) : 0;

/*         calculatedRow5Start = row5.getBoundingClientRect().y - innerHeight/2;
        conditionRow5 = row5Image.getBoundingClientRect().width*0.34 + calculatedRow5Start > 0;
        translate5Calculated = conditionRow5 ? Math.pow(row5Image.getBoundingClientRect().width*0.34 + calculatedRow5Start, 2) : 0; */
    }
    onMount(async () => {
        if(subSelection == 0)  animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
    });
</script>

<svelte:window bind:scrollY={y} bind:innerHeight={innerHeight}/>

<div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 white-bg" id="base-01">
        <div class="row" style="margin-bottom:5%">
            <img class="bg-right" src="./img/home/background-A-v2.png" alt="">
            <img class="home-img-base01 disabe-img" src="./img/logoCVS-color-A.svg" alt="">
            <div class="{responsiveCols}" style="padding:0;">
                <div class="section-1-title-box"><img src="./img/que-es-cvs.svg" alt="" class="section-1-title"></div>
                <div class="section-1-text">
                    <p class="text-content">La certificación de Vivienda Sustentable (CVS) es un sistema voluntario de certificación ambiental
                        que evalúa la implementación de buenas prácticas de diseño y construcción.
                        <br><br>
                        Se pueden aplicar indistintamente en viviendas nuevas, que respondan a cualquiera de las siguientes características:
                    </p>
                </div>

                <div class="icons-container icons-container-section-1">
                    <img class="icon-size" src="./img/icon1-A.svg" alt="">
                    <img class="icon-size" src="./img/icon2-A.svg" alt="">
                    <img class="icon-size" src="./img/icon3-A.svg" alt="">
                    <img class="icon-size" src="./img/icon4-A.svg" alt="">
                    <img class="icon-size" src="./img/icon5-A.svg" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 white-bg" id="base-02" bind:this={row2}>
        <div class="row" style="margin:5% 0;">
            <img class="bg-left" src="./img/home/background-B-v2.png" alt="">
                        <img class="home-img-base02-plant03 disabe-img" src="./img/planta-paralaxC-1.png" alt="" style="{row2Image ? `transform: translateX(${-translate2Calculated/900 > -16 ? -16 : -translate2Calculated/1500}px) scaleX(-1)` : ''}">
            <img bind:this={row2Image} class="home-img-base02 disabe-img" src="./img/home/columpio.png" alt="" style="{row2Image ? `transform: translateX(${-translate2Calculated/2000}px) rotate(${translate2Calculated/20000}deg)` : ''}">

            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-1 col-section-2-content">
                <div class="center-content">
                    <img src="./img/ventajas-beneficios.svg" alt="" class="section-2-title">
                </div>

                <div class="right-text-container">
                    <p class="text-content section-2-text">
                        Las viviendas certificadas tienen un estándar de sustentabilidad superior al
                        promedio del mercado y lo que exigen los instrumentos regulatorios.
                        Son construcciones de alto desempeño ambiental y energético.
                    </p>
                </div>
                <div class="right-text-container">
                    <div class="row icons-container icons-container-section-2">
                        <img class="icon-size" src="./img/icon1-B.svg" alt="">
                        <img class="icon-size" src="./img/icon2-B.svg" alt="">
                        <img class="icon-size" src="./img/icon3-B.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 white-bg" id="base-03" bind:this={row3}>
        <div class="row" style="margin:5% 0;" >
            <img class="bg-right" src="./img/home/background-C-v2.png" alt="">
            <img bind:this={row3Image} class="home-img-base03 disabe-img" src="./img/planta-paralaxC-2.png" alt="" style="{row3Image ? `transform: translateX(${-translate3Calculated/2500 + row3Image.getBoundingClientRect().width*0.6}px)` : ''}">

            <div class="{responsiveCols} category-img-centering" style="padding:0;">
                <img src="./img/categorias.svg" alt="" class="section-3-title">
                <p class="text-content center-small">
                    Categorías evaluadas para la CVS:
                </p>

                <div class="icons-container icons-container-section-3">
                    <div class="box">
                        <img class="icon-size" src="./img/icon1-C.svg" alt="">
                        <img class="icon-size" src="./img/icon2-C.svg" alt="">
                        <img class="icon-size" src="./img/icon3-C.svg" alt="">
                        <img class="icon-size" src="./img/icon4-C.svg" alt="">
                        <img class="icon-size" src="./img/icon5-C.svg" alt="">
                        <img class="icon-size" src="./img/icon6-C.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 white-bg" id="base-04">
        <div class="row" style="margin:5% 0;">
            <img class="bg-left" src="./img/home/background-D-v2.png" alt="">
            <img class="home-img-base04 disabe-img" src="./img/background-categorias-D.svg" alt="">
            <div class="{responsiveCols}" style="padding:0;">
                <div class="center-content">
                    <img src="./img/proceso-certificacion.svg" alt="" class="section-4-title">
                </div>
                <div class="row d-flex align-items-center">
                <div class="col-1 d-flex align-items-center justify-content-center left-arrow-pos">
                    <a href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <div class="carousel-nav-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path d="m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z"/>
                        </svg>
                    </div>
                    </a>
                </div>
                <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                    <div id="carouselExampleIndicators" class="carousel slide">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="row">
                                    <div class="col-12 col-md d-flex justify-content-center">
                                        <div class="row">
                                            <div class="col-12" style="text-align-last: center;">
                                            <img src="./img/icon1-D.svg" alt="" class="carousel-img">
                                            </div>
                                            <div class="col-12">
                                                <p class="text-content" style="margin: 0;">
                                                    Un asesor CVS es quién coordina y documenta el proceso de certificación. <br><br>
                                                    Revisa el registro de asesores acreditados <span on:click={handleClickNav('register',0)} class="link-color">aquí.</span> <br><br>
                                                    Revisa los requisitos para acreditarte como <span on:click={handleClickNav('info',3)} class="link-color">asesor CVS aquí</span>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md d-flex justify-content-center">
                                        <div class="row">
                                            <div class="col-12" style="text-align-last: center;">
                                            <img src="./img/icon2-D.svg" alt="" class="carousel-img">
                                            </div>
                                            <div class="col-12">
                                                <p class="text-content" style="margin: 0;">
                                                    Los proyectos se ingresan en una Plataforma Técnica de administración de la CVS, manejada por el <a class="link-color" href="https://ctecinnovacion.cl/">CTeC</a>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md d-flex justify-content-center">
                                        <div class="row">
                                            <div class="col-12" style="text-align-last: center;">
                                            <img src="./img/icon3-D.svg" alt="" class="carousel-img">
                                            </div>
                                            <div class="col-12">
                                                <p class="text-content" style="margin: 0;">
                                                    El asesor CVS recopilará evidencia técnica en formato digital sobre el cumplimiento de los requerimientos de la certificación.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="row">
                                    <div class="col-12 col-md d-flex justify-content-center">
                                        <div class="row">
                                            <div class="col-12" style="text-align-last: center;">
                                                <img src="./img/icon4-D.svg" alt="" class="carousel-img">
                                            </div>
                                            <div class="col-12">
                                                <p class="text-content" style="margin: 0;">
                                                    Toda la documentación se almacena y registra a través de la Plataforma Técnica para su revisión.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md d-flex justify-content-center">
                                        <div class="row">
                                            <div class="col-12" style="text-align-last: center;">
                                                <img src="./img/icon5-D.svg" alt="" class="carousel-img">
                                            </div>
                                            <div class="col-12">
                                                <p class="text-content" style="margin: 0;">
                                                    La documentación es revisada por una tercera parte, que es independiente e imparcial, y que cuenta con la experiencia necesaria para determinar si la documentación se encuentra en orden.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md d-flex  justify-content-center" >
                                        <div class="row">
                                            <div class="col-12" style="text-align-last: center;">
                                                <img src="./img/icon6-D.svg" alt="" class="carousel-img">
                                            </div>
                                            <div class="col-12">
                                                <p class="text-content" style="margin: 0;">
                                                    La Precertificación se entrega una vez que se ha comprobado que el proyecto cumple satisfactoriamente con los requerimientos de diseño y la obtención del permiso de edificación. <br><br> La Certificación se entrega una vez que se ha comprobado que el proyecto cumple satisfactoriamente con los requerimientos de diseño y construcción, junto con la obtención de la recepción definitiva.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-1 d-flex align-items-center justify-content-center" style="position:absolute;right:0;">
                        <a  href="#carouselExampleIndicators" data-slide="next">
                            <div class="carousel-nav-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"/>
                                </svg>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .left-arrow-pos{
        position: relative;
    }

    .link-color{
        color: #95c121;
        cursor: pointer;
    }

    .link-color:hover {
        text-decoration: underline;
    }

    .section-1-title-box{
        max-width: 800px;
        text-align: center;
    }

    #base-01{
        padding-top: 80px;
    }

    .home-img-base01{
        position: absolute;
        width: 35vh;
        height: 35vh;
        right: 12vh;
        top: 10vh;
    }

    .home-img-base02{
        position: absolute;
        top: 0;
        left: 0;
        height: 80%;
    }

    .home-img-base02-plant01{
        position: absolute;
        top: 67vh;
        left: -3%;
        height: 48vh;
    }

    .home-img-base02-plant02{
        position: absolute;
        top: 67vh;
        left: 20%;
        height: 48vh;
    }

    .home-img-base03{
        position: absolute;
        right: 0%;
        height: 100vh;
        top: 0;
        z-index: 5;
    }

    .home-img-base05{
        position: absolute;
        height: 95%;
        right: -40%;
        bottom: -4px
    }

    .icon-size-info{
        height: 20vh;
        margin: 10px;
    }

    .img-with-text {
        text-align: justify;
        width: 37vh;
    }

    .img-with-text img {
        display: block;
        margin: 0 auto;
    }

    .bg-right{
        right: 0;
        height: 100%;
        top: 0;
        width: auto;
        position: absolute;
    }

    .bg-left{
        left: 0;
        height: 100%;
        top: 0;
        width: auto;
        position: absolute;
    }

    .home-img-base04{
        z-index: 0;
        height: 100%;
        position: absolute;
        left: 2%;
        top: 0;
    }

    .icons-container-section-1{
        display: flex;
        justify-content: space-between;
        max-width: 1100px;
        flex-wrap: wrap;
        margin: 0 -10px;
        place-content: center;
        float: left;
    }

    .icons-container-section-2{
        display: flex;
        justify-content: space-between;
        max-width: 700px;
        flex-wrap: wrap;
        margin: 0 -10px;
        width: 100%;
    }

    .icons-container-section-3{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 0 -10px;
        place-content: center;
        float: left;
        width: 100%;
        justify-content: left;
    }

    .icons-container-section-2 .icon-size{
        margin: 10px;
    }

    .icons-container-section-1 .icon-size{
        margin: 10px;
    }

    .icons-container-section-3 .icon-size{
        margin: 10px;
    }

    .right-adjust{
        text-align: right;
        justify-content: flex-end;
    }

    .section-1-text{
        max-width: 800px;
    }

    .section-1-title{
        width: 100%;
        max-width: 600px;
    }

    .section-2-title{
        width: 100%;
        max-width: 800px;
    }

    .section-2-text{
        max-width: 600px;
    }

    .section-3-title{
        max-width: 380px;
        width: 100%;
    }

    .section-4-title{
        max-width: 710px;
        width: 100%;
    }

    .section-5-title{
        max-width: 430px;
        width: 100%;
    }

    .right-text-container{
        justify-content: flex-end;
        display: flex;
        padding: 0 15px;
    }

    .col-section-2-content{
        padding:0;
        margin-left: 6.4%;
    }
    
    @media (max-width: 1919px){
        .icons-container-section-3 .box{
            max-width: 520px;
        }
    }


    @media (max-width: 1400px){
        .disabe-img {
            display:none;
        }
        .section-1-title-box, .section-1-text{
            max-width: none;
        }
        .icons-container{
            justify-content: center;
        }
        .text-content{
            text-align: justify;
        }

        .right-text-container{
            padding: 0 0px;
        }

        .col-12, .col-sm-10, .col-md-10, .right-text-container{
            text-align: center;
            justify-content: center;
        }
        .center-small{
            text-align: center !important;
        }
        .col-section-2-content{
            margin-left: 16.666667%;
        }
        .section-2-text{
            max-width: none;
        }
        .icons-container-section-3{
           justify-content: center;
           text-align: -webkit-center;
        }
        .category-img-centering{
            text-align: -webkit-center;
        }
        .icons-container-section-1{
                float: none;
        }
    }

    @media (max-width: 768px){
        .col-section-2-content{
            margin-left: 8.333333%;
        }
    }



    .center-content{
        display: flex;
        justify-content: center;
    }

    .grey-text{
        color: #9C9B9B;
        font-family: 'suga-pro-extralight';
        font-weight: bold;
        letter-spacing: 1px;
    }

    .carousel-img{
        height: 20vh;
        margin-bottom: 15px;
    }

    .home-img-base02-plant03{
        margin-bottom: -11vh;
    }

    @media (max-width: 575px){
        .section-1-text{
            padding: 0 15px;
        }

    }

    @media (max-height: 732px){
        .icons-container-section-2, .icons-container-section-4{
            max-width: 520px;
        }
        .icons-container-section-1{
            max-width: 800px;
        }

    }

    @media (max-width: 576px){
        .col-section-2-content {
            margin-left: 8.333333%;
        }
        .left-arrow-pos{
            position: absolute;
        }
    }


    @media (max-height: 546px) and (min-height: 520px){
        .icons-container-section-1{
                max-width: 800px;
                float: none;
        }

    }

    @media (max-height: 732px) and (min-height: 520px){
        .icons-container-section-1{
                float: none;
        }

    }

    @media (max-height: 546px){
        .icons-container{
            max-width: 420px;
        }
        .icons-container-section-1{
            max-width: 800px;
            float: none;
        }

    }

    @media (max-width: 576px){
        .col-section-2-content{
            margin-left: 0;
        }

    }

    @media (max-width: 1365px) and (min-height: 700px){
        .icons-container-section-1{
            float: none;
        }
    }

    @media (max-width: 1365px) and (min-height: 492px){
        .icons-container-section-1{
            float: none;
        }
    }

</style>